export const Translations = {
    "en-US": `locales/en-US/translation.json`,
    "pt-BR": `locales/pt-BR/translation.json`,
    "es-PA": `locales/es-PA/translation.json`,
    "es": `locales/es/translation.json`
};

export const TranslationsOptions = [
    { name: "English - US", shortName: "en-US" },
    { name: "Português - Brasil", shortName: "pt-BR" },
    { name: "Español", shortName: "es" }
];

/**
       * sprint3200
       * Passando as novas informações de menu, abreviado
       * para tela de login.
       */


export const TranslationsOptionsAbr = [
    { name: "US", shortName: "en-US" },
    { name: "BR", shortName: "pt-BR" },
    { name: "ES", shortName: "es" }
];